import { Link } from "react-router-dom";

function News() {
  return (
    <main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath  startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to="/">Home</Link> / News</div>
      <h1>News &amp; Events</h1>
      <p>Official news, notices, press releases, circulars and scheme updates published by the Authority.</p>
    </div>
  </div>

  <section className="section">
    <div className="container">

      <div className="filter-row">
        <span className="pill is-active">News</span>
        <span className="pill">Notices</span>
        <span className="pill">Press Releases</span>
        <span className="pill">Schemes</span>
        <span className="pill">Circulars</span>
      </div>

      <article className="featured-news">
        <div className="featured-news__media">
          <img src="/images/news/seminar.jpg" alt="img" />
        </div>
        <div className="featured-news__body">
          <span className="date-line">20 June 2026</span>
          <h2>Authority launches single-window portal for legal aid applications and complaints</h2>
          <p>Citizens across all districts can now submit applications for free legal aid and register grievances through one online window, removing the need to visit the office in person for the initial filing.</p><p>The portal provides a simple, accessible, and transparent way for citizens to seek legal assistance and report their concerns from anywhere.</p>
          <Link to="/application" target="_blank" rel="noopener noreferrer" className="read-more">Apply for Legal Aid &rarr;</Link>
        </div>
      </article>

      <div className="grid-3">
        <article className="news-card">
          <div className="news-card__media"><img src="/images/news/adov_training.jpg" alt="img" width='100%' height='100%' /></div>
          <div className="news-card__body">
            <span className="date-line">12 Aug 2026</span>
            <h3>Awarded training certificates to LAJA nominated Advocates</h3>
            <p>Adil Anwar The Director General of Legal Aid and Justice Authority (LAJA) awarded training certificates to LAJA nominated Advocates upon successful completion of specialized training in mediation and arbitration.</p>
            <Link to="https://www.linkedin.com/feed/update/urn:li:activity:7493210927518040064" target="_blank" rel="noopener noreferrer" className="read-more">Read news &rarr;</Link>
          </div>
        </article>
      
        <article className="news-card">
          <div className="news-card__media"><img src="/images/news/forensic_training.jpg" alt="img" width='100%' height='100%' /></div>
          <div className="news-card__body">
            <span className="date-line">9 Aug 2026</span>
            <h3>LAJA conducts specialized Trainings on Forensic Evidence Literacy for Panel Advocates</h3>
            <p>The Legal Aid and Justice Authority (LAJA) recently organized an insightful and highly technical one-day training session on Forensic Evidence Literacy for its panel advocates.</p>
            <Link to="https://www.linkedin.com/feed/update/urn:li:activity:7490027552384823297" target="_blank" rel="noopener noreferrer" className="read-more">Read news &rarr;</Link>
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__media"><img src="/images/news/uk_par_member.jpg" alt="img" width='100%' height='100%' /></div>
          <div className="news-card__body">
            <span className="date-line">17 July 2026</span>
            <h3>Meeting with Lord Aamer Sarfraz, Member of the House of Lords, the upper house of the United Kingdom Parliament.</h3>
            <p>Adil Anwar, Director General of the LAJA met with Lord Aamer Sarfraz, Member of the House of Lords, the upper house of the United Kingdom Parliament.</p>
            <Link to="https://www.linkedin.com/feed/update/urn:li:activity:7483821273236762624" target="_blank" rel="noopener noreferrer" className="read-more">Read news &rarr;</Link>
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__media"><img src="/images/news/ihc_judges.jpg" alt="img" width='100%' height='100%' /></div>
          <div className="news-card__body">
            <span className="date-line">16 July 2026</span>
            <h3>Consultative meeting with the Hon'ble Judges of Islamabad High Court, Islamabad.</h3>
            <p>Adil Anwar, the Director General of Legal Aid and Justice Authority (LAJA), held a consultative meeting with Mr. Justice Inaam Ameen Minhas and Mr. Justice Muhammad Azam Khan, the Hon'ble Judges of Islamabad High Court, Islamabad.</p>
            <Link to="https://www.linkedin.com/feed/update/urn:li:activity:7483482273942724608" target="_blank" rel="noopener noreferrer" className="read-more">Read news &rarr;</Link>
          </div>
        </article>
       
      </div>

      <nav className="pagination" aria-label="News pagination">
        <Link to="" aria-label="Previous page">&lsaquo;</Link>
        <Link to="" className="is-current">1</Link>
        {/* <Link to="">2</Link>
        <Link to="">3</Link> */}
        <Link to="" aria-label="Next page">&rsaquo;</Link>
      </nav>

    </div>
  </section>

</main>
  );
}

export default News;
